import React from "react";
import SkeletonLoading from "../../SkeletonLoading";

const GridLoadingOverlay: React.FC = () => {
  return (
    <div className="w-full h-full p-2 bg-white">
      <SkeletonLoading type="table" rows={8} columns={6} />
    </div>
  );
};

export default GridLoadingOverlay;